<div class="table-container">
  <!-- Filter -->
  <div class="filter-container">
    @if (filter) {
      <mat-form-field class="mt-20 col-xs-12 field-filtre">
        <mat-label>Filter</mat-label>
        <input matInput [formControl]="filterControl" #filterInput />
        @if (filterControl.value) {
          <button matSuffix mat-icon-button aria-label="Clear" (click)="filterControl.setValue('')">
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }
  </div>
  <!-- Table -->
  <table mat-table [dataSource]="dataSource" matSort>
    <!-- Checkbox Column -->
    @if (selectable) {
      <ng-container matColumnDef="Sélectionner">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            color="primary"
            (change)="$event ? toggleAllRows() : null"
            [checked]="isAllSelected()"
            [indeterminate]="getSelectedItems().length > 0 && !isAllSelected()"
            [aria-label]="checkboxLabel()"
            >
          </mat-checkbox>
          <span class="selection-label">Sélectionner</span>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            color="primary"
            (click)="$event.stopPropagation()"
            (change)="toggleSelection(row)"
            [checked]="isSelected(row)"
            [aria-label]="checkboxLabel(row)"
            >
          </mat-checkbox>
        </td>
      </ng-container>
    }

    <!-- Data Columns -->
    @for (column of displayedColumns; track column) {
      <ng-container [matColumnDef]="column">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          [disabled]="column === 'Sélectionner' || column === 'Statut' || column === 'Actions'"
          [ngStyle]="headerStyleCss[column] || {}"
          >
          {{ column }}
        </th>
        <td mat-cell *matCellDef="let element" [ngStyle]="cellStyleCss[column] || {}">
          <!-- Object type data (like status with class) -->
          @if (isObjectType(element[column])) {
            <div [class]="element[column].class">
              @if (element[column].icon) {
                <mat-icon>
                  {{ element[column].text }}
                </mat-icon>
              } @else {
                {{ element[column].text }}
              }
            </div>
          }
          <!-- Regular data -->
          @if (!isObjectType(element[column]) && column !== 'Actions') {
            {{ element[column] }}
          }
          <!-- Actions column -->
          @if (column === 'Actions') {
            @for (action of element.actionOrder || ['validate', 'refuse', 'detail', 'edit', 'delete', 'download', 'autorenew']; track action) {
              @if (action === 'validate' && validable && !element.valider_hidden) {
                <button
                  class="bt-action text-success"
                  matTooltip="Valider"
                  mat-button
                  (click)="validateSingleItem(element)"
                  >
                  <mat-icon>done</mat-icon>
                </button>
              }
              @if (action === 'refuse' && refusable && !element.refuser_hidden) {
                <button
                  class="bt-action text-danger"
                  matTooltip="Refuser"
                  mat-button
                  (click)="refuseSingleItem(element)"
                  >
                  <mat-icon>clear</mat-icon>
                </button>
              }
              @if (action === 'recallRefuse' && recallRefusable && !element.recallRefuse_hidden) {
                <button
                  class="bt-action recall-refuse-action"
                  matTooltip="Annuler le refus"
                  mat-button
                  (click)="recallRefuse(element)"
                  >
                  <mat-icon>change_circle</mat-icon>
                </button>
              }
              @if (action === 'detail' && hasView && !element.view_hidden) {
                <button
                  class="bt-action"
                  matTooltip="Voir détails"
                  mat-button
                  (click)="showTableDetail(element)"
                  >
                  <mat-icon class="icon-zoom">zoom_in</mat-icon>
                </button>
              }
              @if (action === 'advice' && advicable && element.showAdvice) {
                <button
                  class="bt-action"
                  matTooltip="Demande d'avis à traiter"
                  mat-button
                  (click)="getAdvice(element)"
                  >
                  <mat-icon style="color: #f5cd30">star_border</mat-icon>
                </button>
              }
              @if (action === 'edit' && editable && !element.edit_hidden) {
                <button
                  class="bt-action"
                  matTooltip="Modifier"
                  mat-button
                  (click)="editSingleItem(element)"
                  >
                  <mat-icon>edit</mat-icon>
                </button>
              }
              @if (action === 'autorenew' && renewable && !element.renew_hidden) {
                <button
                  class="bt-action"
                  matTooltip="Renouveler"
                  mat-button
                  (click)="renewItem(element)"
                  >
                  <mat-icon>autorenew</mat-icon>
                </button>
              }
              @if (action === 'delete' && deletable && !element.delete_hidden) {
                <button
                  class="bt-action"
                  matTooltip="Supprimer"
                  mat-button
                  (click)="deleteSingleItem(element)"
                  >
                  <mat-icon>delete</mat-icon>
                </button>
              }
              @if (action === 'download' && downloadable && !element.download_hidden) {
                <button
                  class="bt-action"
                  matTooltip="Télécharger"
                  mat-button
                  (click)="downloadSingleItem(element)"
                  >
                  <mat-icon>download</mat-icon>
                </button>
              }
              @if (action === 'downloadPJ' && downloadablePJ && !element.downloadPJ_hidden) {
                <button
                  class="bt-action"
                  matTooltip="Pièces jointes"
                  mat-button
                  (click)="downloadPJ(element)"
                  >
                  <mat-icon>attach_file</mat-icon>
                </button>
              }
            }
          }
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="effectiveDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: effectiveDisplayedColumns"></tr>

    <!-- No data row -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="effectiveDisplayedColumns.length">Aucune donnée n'a été trouvée.</td>
    </tr>
  </table>

  <!-- Paginator -->
  @if (hasPagination) {
    <mat-paginator
      [pageSizeOptions]="[10, 15, 20, 25, 30, 40, 50, 75, 100]"
      [pageSize]="limit"
      [pageIndex]="offset"
      [length]="length"
      showFirstLastButtons
      style="border-top: 1px solid rgba(0, 0, 0, 0.12)"
      >
    </mat-paginator>
  }
</div>
